
import { Vue, Component } from "vue-property-decorator";
import { getEmployeesStats } from "@/api/offers";
import AdministrationOffersLayout from "@/components/layout/AdministrationOffersLayout.vue";

@Component({
    methods: { getEmployeesStats },
    components: { AdministrationOffersLayout },
})

export default class Stats extends Vue {}
